import { postRequest, HTTPError } from '../http'
import config from '../../config'
import { submissionService } from '@oneblink/apps-react'
export type GetDraftMetaResponse = {
  draftDataUrl: string
  formId: number
  username: string
}

export async function saveDraft(
  draft: submissionService.NewDraftSubmission,
  qsTrackingCode?: string,
): Promise<string> {
  const payload = {
    trackingCode: qsTrackingCode,
    formId: draft.definition.id,
    formsAppId: config.FORMS_APP_ID,
  }

  const { url, trackingCode } = await postRequest<{
    url: string
    trackingCode: string
  }>({
    url: `${config.HOSTED_API_URL}/drafts`,
    resource: payload,
    addAuthHeaders: draft.definition.isAuthenticated,
  })

  await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
    body: JSON.stringify(draft),
  })

  return trackingCode
}

export async function getDraftMeta(
  trackingCode: string,
): Promise<GetDraftMetaResponse> {
  const res: GetDraftMetaResponse = await postRequest({
    url: `${config.HOSTED_API_URL}/drafts/${trackingCode}`,
    resource: { formsAppId: config.FORMS_APP_ID },
    addAuthHeaders: true,
  })
  return res
}

export async function getDraftData(
  draftDataUrl: string,
): Promise<Record<string, unknown>> {
  const response = await fetch(draftDataUrl)

  try {
    const body = await response.json()

    if (response.ok) {
      // backwards-compatible check for drafts saved as either just draft data, or with submission and definition
      if (body.submission && body.definition) {
        return body.submission
      }

      return body
    }

    throw new HTTPError(response.status, body.message)
  } catch (e) {
    console.warn(e)
    // @ts-expect-error void is ok here
    if (response.ok) return

    throw e
  }
}
